import { privateApi } from '@/config/axios.config';
import { Condominium } from '../types/condominium.types';

const API_BASE = '/condominium/condominiums';

export interface CondominiumCreateDTO {
  name: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    country?: string;
    zipCode?: string;
    neighborhood?: string;
    coordinates?: {
      latitude?: number;
      longitude?: number;
    };
  };
  type: 'towers' | 'houses' | 'mixed';
  configuration?: {
    rules?: string;
    currency?: string;
    language?: string;
    timezone?: string;
    [key: string]: any;
  };
  description?: string;
  metadata?: Record<string, any>;
}

export interface CondominiumUpdateDTO extends Partial<CondominiumCreateDTO> {
  id?: string;
}

export type CondominiumType = 'towers' | 'houses' | 'mixed';

export interface CondominiumFilters {
  type?: CondominiumType;
  search?: string;
  page?: number;
  limit?: number;
}

export const condominiumsApiService = {
  // Obtener todos los residenciales con filtros
  async getCondominiums(filters: CondominiumFilters = {}): Promise<{
    condominiums: Condominium[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  }> {
    const params = new URLSearchParams();

    if (filters.type) params.append('type', filters.type);
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());

    const response = await privateApi.get(`${API_BASE}?${params.toString()}`);
    return response.data?.data || response.data;
  },

  // Obtener un residencial por ID
  async getCondominiumById(id: string): Promise<Condominium> {
    const response = await privateApi.get(`${API_BASE}/${id}`);
    return response.data?.data || response.data;
  },

  // Crear un nuevo residencial
  async createCondominium(data: CondominiumCreateDTO): Promise<Condominium> {
    const response = await privateApi.post(API_BASE, data);
    return response.data?.data || response.data;
  },

  // Actualizar un residencial
  async updateCondominium(id: string, data: CondominiumUpdateDTO): Promise<Condominium> {
    const response = await privateApi.patch(`${API_BASE}/${id}`, data);
    return response.data?.data || response.data;
  },

  // Eliminar un residencial
  async deleteCondominium(id: string): Promise<void> {
    await privateApi.delete(`${API_BASE}/${id}`);
  },

  // Obtener estadísticas de un residencial
  async getStats(id: string): Promise<{
    totalUnits: number;
    occupiedUnits: number;
    vacantUnits: number;
    totalResidents: number;
    activeResidents: number;
  }> {
    const response = await privateApi.get(`${API_BASE}/${id}/stats`);
    return response.data?.data || response.data;
  },
};

